import apiClient from "./apiClient";
import { AxiosResponse } from "axios";
import { SiteParametersResponse } from "./Models/SiteParametersModel";
import {
  RowFilterDocumentsRequest,
  RowFilterDocumentsResponse,
} from "./Models/DocumentsModel";
import { PagingInfo } from "./Models/BaseModel";
import { IDmsPageResponse } from "./Models/DmsPagination";

export const getDocuments = async (
  securityToken: string,
  language: string,
  filterId: number,
  objectId: number,
  Anteprima?: boolean //se = true scarica anche i link
): Promise<IDmsPageResponse<RowFilterDocumentsResponse>> => {
  let siteParameters: SiteParametersResponse = JSON.parse(
    localStorage.getItem("SiteParameters") ?? ""
  ) as SiteParametersResponse;

  const pageRequest: PagingInfo = {
    CurrentPage: 1,
    PageSize: undefined,
  };
  const requestData: RowFilterDocumentsRequest = {
    SecurityToken: securityToken,
    Language: language,
    IdFilter: filterId,
    IdObject: objectId,
    Anteprima: Anteprima
      ? true
      : siteParameters.Anteprima === "1"
      ? true
      : false,
  };

  try {
    const response: AxiosResponse<RowFilterDocumentsResponse> = await apiClient(
      {
        method: "post",
        url: "/FilterDetails/CMSGetDocuments",
        data: requestData,
      }
    );
    const responsePage: IDmsPageResponse<RowFilterDocumentsResponse> = {
      count: response.data.Docs ? response.data.Docs.length : 0,
      totalCount: response.data.Docs ? response.data.Docs.length : 0,
      page: 1,
      pageSize: 0,
      pageCount: 1,
      data: [response.data],
      availableFieldDescriptors: [],
    };
    return responsePage;
  } catch (error) {
    console.error("CMSGetDocuments Error:", error);
    throw error;
  }
};
